import { get, post } from '@/utils/fetch'
import type { EmailVerifyStatus } from '@/interfaces/email'
import type { TUserPrivateInfo } from '@/interfaces/user'

export const usernameAvailable = async (username: string) => {
  const available = await get<boolean>(`/user/username-available/${username}`)
  return available
}

export const emailAvailable = async (email: string) => {
  const available = await get<boolean>(`/user/email-available/${email}`)
  return available
}

export const emailAuth = async (email: string, query?: Record<string, unknown>) => {
  let queryString = ''
  if (query) {
    queryString = Object.entries(query).map(([ key, value ]) => `${key}=${encodeURIComponent(`${value}`)}`).join('&')
  }
  const result = await post<{id: string}>('/auth/email/', { email, queryString })
  return result
}

// メールで届いたOTPコードを照合してログイン/サインアップを完了する
export const emailVerifyOtp = async (email: string, code: string) => {
  const result = await post<EmailVerifyStatus>('/auth/email/verify', { email, code })
  return result
}

export const updateEmail = async (email: string) => {
  const result = await post<{id: string}>('/auth/email/update', { email })
  return result
}

// メールで届いたOTPコードを照合してメールアドレス変更を確定する
export const updateEmailVerifyOtp = async (code: string) => {
  const result = await post<{message: string}>('/auth/email/update/verify', { code })
  return result
}

// メールアドレス変更を中断し、保留中の新メールアドレスとコードを破棄する
export const cancelUpdateEmail = async () => {
  const result = await post<{message: string}>('/auth/email/update/cancel', {})
  return result
}

export const googleLogin = async (token: string) => {
  const result = await post<TUserPrivateInfo & {token: string, registered: boolean}>('/auth/google', {
    token,
  })
  return result
}
